import React from 'react';
import axios from "axios";
import { connect } from 'react-redux';
import { editarNumeroPatronal, guardarNumeroPatronal } from '../../components/numeroPatronal/NumeroPatronalService';
import { URL, getAuthorizationHeader } from '../../constans/constants';
import { Accordion, Button } from 'react-bootstrap';
import arrowBack from '../../styles/icons/arrow_back.svg'
import safeRedirectManager from '../seguridad/SafeRedirectComponent';

class VistaPDF extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fechaCarga: "",
      empleado: "",
      estado: "",
      estadoMTESS: false,
      redirect: "",
      comentario: null,
      pdfBase64: null,
      loading: true,
      error: null
    }
    let pantallaAnterior = this.setPantallaAnterior();
  }

  componentWillUnmount() {
    const viewerFrame = document.getElementById('pdf-js-viewer');
    if (viewerFrame && viewerFrame.contentWindow) {
      viewerFrame.contentWindow.document.removeEventListener('click', this.handlePDFClick);
      viewerFrame.contentWindow.document.removeEventListener('contextmenu', this.handlePDFRightClick);
    }
  }

  setPantallaAnterior = () => {
    this.pantallaAnterior = (localStorage.getItem("urlAnterior")).substring(localStorage.getItem("urlAnterior").indexOf("#"))
  }

  fetchPDF = async () => {
    try {
      const requestUrl = `${URL}recibo/lote/${this.props.match.params.lote}/recibo/${this.props.match.params.recibo}`;
      const response = await axios.get(requestUrl, {
        ...getAuthorizationHeader(),
        responseType: 'arraybuffer'
      });

      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ''
        )
      );

      this.setState({
        pdfBase64: base64,
        loading: false
      });

      // Una vez que tenemos el base64, actualizamos el visor de PDF
      this.updatePDFViewer(base64);
    } catch (error) {
      console.error('Error fetching PDF:', error);
      this.setState({
        error: 'Error al cargar el PDF',
        loading: false
      });
    }
  }

  handlePDFClick = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
      event.preventDefault();
      console.log('Enlace clickeado:', target.href);
      // Aquí puedes manejar el enlace clickeado como desees
      safeRedirectManager.safeRedirect(target.href);
    }
  }

  handlePDFRightClick = (event) => {
    const target = event.target;
    if (target.tagName === 'A' && target.href) {
      event.preventDefault();
    }
  }

  updatePDFViewer = (base64Data) => {

    const viewerFrame = document.getElementById('pdf-js-viewer');
    if (viewerFrame) {
      viewerFrame.onload = () => {
        try {
          const viewerWindow = viewerFrame.contentWindow;

          if (viewerWindow.PDFViewerApplication) {

            const pdfUrl = `data:application/pdf;base64,${base64Data}`;

            // Cargar el PDF usando el nuevo método
            viewerWindow.PDFViewerApplication.initializedPromise.then(() => {
              viewerWindow.PDFViewerApplication.open({
                url: pdfUrl
              }).catch(error => {
                console.error('Error loading PDF:', error);
              });
              // Agregar listener de eventos de clics
              viewerWindow.document.addEventListener('click', this.handlePDFClick);
              // Agregar listener de eventos de clic derecho
              viewerWindow.document.addEventListener('contextmenu', this.handlePDFRightClick);
            });
          }
        } catch (error) {
          console.error('Error updating PDF viewer:', error);
        }
      };
    }


  }

  componentDidMount() {
    this.fetchPDF();

    // Get comments
    const urlComment = `${URL}lote/${this.props.match.params.lote}/recibo/${this.props.match.params.recibo}/comment`;

    axios
      .get(urlComment, getAuthorizationHeader())
      .then(res => {
        if (!res.data.errors)
          this.setState({ comentario: res.data.datos })
      })
  }

  descargarRecibo = () => {
    if (this.state.pdfBase64) {
      const linkSource = `data:application/pdf;base64,${this.state.pdfBase64}`;
      const downloadLink = document.createElement("a");
      const fileName = `recibo_${this.props.match.params.recibo}.pdf`;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }

  render() {
    return (
      <div>
        <div className="dashboardContent">
          <div className="container-fluid">
            <div className="sectionHeader" style={{ paddingBottom: '20px' }}>
              <h1 className="pageTitle"> Recibo nro. {this.props.match.params.recibo} </h1>
              <div className="actions">
                <Button
                  variant="success"
                  onClick={this.descargarRecibo}
                  disabled={!this.state.pdfBase64}
                >
                  Descargar Recibo
                </Button>
              </div>
            </div>
            <div className="contentPage card">
              <a onClick={() => window.location.href = this.pantallaAnterior} type="Button" className="backPage">
                <img src={arrowBack} alt="Back arrow"></img>
                volver a la página anterior
              </a>
              {
                this.state.comentario != null &&
                <Accordion defaultActiveKey='0' alwaysOpen style={{ marginTop: '20px', marginBottom: '20px' }}>
                  <Accordion.Item eventKey='0'>
                    <Accordion.Header><h6>Comentario</h6></Accordion.Header>
                    <Accordion.Body>
                      <small>{this.state.comentario}</small>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              }
              <div id="container-file">
                <div className="iframeVisor">
                  {this.state.loading ? (
                    <div>Cargando PDF...</div>
                  ) : this.state.error ? (
                    <div>{this.state.error}</div>
                  ) : (
                    <iframe
                      id="pdf-js-viewer"
                      //src="../../../lib/web/viewer.html"
                      src="../../../mirecibo/lib/web/viewer.html"
                      title="webviewer"
                      frameBorder="0"
                      width="100%"
                      height="100%"
                    ></iframe>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  guardarNumeroPatronal: value => dispatch(guardarNumeroPatronal(value)),
  editarNumeroPatronal: value => dispatch(editarNumeroPatronal(value))
});

export default connect(null, mapDispatchToProps)(VistaPDF);